import { render, staticRenderFns } from "./VendFiscalDetails.vue?vue&type=template&id=13d30924&scoped=true&"
import script from "./VendFiscalDetails.vue?vue&type=script&lang=js&"
export * from "./VendFiscalDetails.vue?vue&type=script&lang=js&"
import style0 from "./VendFiscalDetails.vue?vue&type=style&index=0&id=13d30924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d30924",
  null
  
)

export default component.exports